import React from 'react';
import './index.css';

export default class HighScore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highScore: 0,
    }
    this.updateScore = this.updateScore.bind(this)
  }

  updateScore () {
    this.setState({score: this.state.score + 1})
  }

  componentDidMount(){
    let score;
    if (this.props.difficulty === 1) {
      score = localStorage.getItem("highScoreEasy") || 0
    } else if (this.props.difficulty === 2) {
      score = localStorage.getItem("highScoreMedium") || 0
    } else {
      score = localStorage.getItem("highScoreHard") || 0
    }
    this.setState({highScore:score})
  }

  componentWillUnmount() {
    //clearInterval(this.state.updateScoreInt)
  }

  componentDidUpdate(prevProps){
    if(prevProps.playing === true && !this.props.playing) {
        if (this.props.score > this.state.highScore){
          if (this.props.difficulty === 1) {
            localStorage.setItem("highScoreEasy", this.props.score)
          } else if (this.props.difficulty === 2) {
            localStorage.setItem("highScoreMedium", this.props.score)
          } else {
            localStorage.setItem("highScoreHard", this.props.score)
          }
          this.setState({highScore:this.props.score})
        }
    }
  }

  render() {
    return (
        <h2 id='highScore'>High Score: {this.state.highScore}</h2>   
    )
  }
}



